import { InformationBanner } from '@blocks/information-banner'
import { PageContext } from '@contexts/page'
import { type BANNER_SEVERITY } from '@utils/banners'
import React, { type FC, useContext } from 'react'

import Header from './menu'

type NavbarProps = {
  informationBanner?: Queries.StaticPageInformationBannerFragment
  isLightMode?: boolean
  isLandingPage?: boolean
  isHiddenCTA?: boolean
  cta?: Queries.EntryFragment
}

export const Navbar: FC<NavbarProps> = ({
  informationBanner,
  isLightMode = true,
  isLandingPage = false,
  cta,
  isHiddenCTA,
}) => {
  const { ctaRefs } = useContext(PageContext) || {}

  return (
    <>
      <Header
        cta={cta || ctaRefs?.[0]}
        isHiddenCTA={isHiddenCTA}
        isLandingPage={isLandingPage}
        isLightMode={isLightMode}
      />
      {informationBanner && (
        <InformationBanner
          bannerId={informationBanner.contentful_id}
          link={informationBanner.link}
          modificationDate={informationBanner.updatedAt}
          severity={informationBanner.severity as BANNER_SEVERITY}
          text={informationBanner.content.text}
        />
      )}
    </>
  )
}
